import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DataManagerService } from 'src/app/services/DataManager/data-manager.service';
import { BaseComponent } from 'src/app/shared/abstract/base.component';
import { AppConstants } from 'src/app/shared/constants/app-constants';

@Component({
  selector: 'app-add-purpose-of-donation-dialog',
  templateUrl: './add-purpose-of-donation-dialog.component.html',
  styleUrls: ['./add-purpose-of-donation-dialog.component.css'],
})
export class AddPurposeOfDonationDialogComponent
  extends BaseComponent
  implements OnInit
{
  public purposeOfDonationForm: FormGroup;
  public loged_user = JSON.parse(localStorage.getItem('user') || 'null');
  public donationTypeUrl: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    dataManagerService: DataManagerService,
    private datePipe: DatePipe,
    public dialogRef: MatDialogRef<AddPurposeOfDonationDialogComponent>,
  ) {
    super();
    this.service = dataManagerService;
    this.donationTypeUrl =
      AppConstants.BASE_URL + AppConstants.ADDDONATIONTYPE_URL;
    if (dialogData) {
      this.headings = 'Update Purpose of Donation';
      this.buttonText = 'Update';
    } else {
      this.headings = 'Create Purpose of Donation';
      this.buttonText = 'Save';
    }
  }
  ngOnInit(): void {
    this.setdonationTypeForm();
  }
  get purposeOfDonationFormControl() {
    return this.purposeOfDonationForm.controls;
  }
  setdonationTypeForm() {
    this.purposeOfDonationForm = this.formBuilder.group({
      type_name: [
        this.dialogData && this.dialogData.data.type_name
          ? this.dialogData.data.type_name
          : '',
        [Validators.required],
      ],
    });
  }

  onSubmit() {
    if (this.dialogRef.getState() == 0) {
      this.submitted = true;
      if (this.purposeOfDonationForm.invalid) {
        return;
      } else {
        this.loadFlag2 = true;
        if (this.dialogData) {
          this.purposeOfDonationForm.value.donation_type_id =
            this.dialogData.data.donation_type_id;
        }
        this.service
          .create(this.donationTypeUrl, this.purposeOfDonationForm.value)
          .subscribe({
            next: (res: any) => {
              if (res['status'] == 'success') {
                this.loadFlag2 = false;
                this.dialogRef.close(true);
                this.service.showSnackBar(res.message, 'ok', 3000);
              } else {
                this.loadFlag2 = false;
                this.topErrorMessage = res.message;
                this.keys = Object.keys(this.topErrorMessage);
                this.keys1 = Object.values(this.topErrorMessage);
                let i;
                let j;
                const name = [
                  'donation_amount',
                  'donation_type',
                  'fname',
                  'fname',
                  'lname',
                  'email',
                  'contact_number',
                  'contact_number',
                  'province',
                  'city',
                  'payment_method',
                ];
                for (i = 0; i < this.keys.length; i++) {
                  for (j = 0; j < name.length; j++) {
                    if (this.keys[i].match(name[j])) {
                      const documents = document.getElementById(name[j]);
                      if (documents) {
                        documents.style.borderColor = '#a94442';
                        documents.style.display = 'block';
                      }
                    }
                  }
                }
              }
            },
            error: (error) => {
              this.loadFlag2 = false;
              this.service.showSnackBar(error.message, 'ok', 3000);
            },
          });
      }
    } else {
      this.loadFlag2 = false;
      this.dialogRef.close(true);
    }
  }
  cancel() {
    this.dialogRef.close(true);
  }
}
